// OneTrust consent categories
export const ConsentCategory = {
    StrictlyNecessary: 'C0001',
    Performance: 'C0002',
    Functional: 'C0003',
    Targeting: 'C0004',
    SocialMedia: 'C0005',
};

const isCookieConsentEnabled = () =>
    document.getElementById('bootstrap-data-isCookieConsentEnabled')?.textContent.trim() === 'true';

const getActiveGroups = () =>
    typeof window.OnetrustActiveGroups === 'string' ? window.OnetrustActiveGroups : undefined;

const groupsInclude = (groups, category) =>
    groups.split(',').map(s => s.trim()).includes(category);

const noop = () => {};

export const onCategoryAllowed = (category, callback) => {
    const consentEnabled = isCookieConsentEnabled();
    const initialGroups = getActiveGroups();

    if (!consentEnabled) {
        callback();
        return noop;
    }

    if (initialGroups !== undefined && groupsInclude(initialGroups, category)) {
        callback();
        return noop;
    }

    const onUpdate = () => {
        const updated = getActiveGroups();
        if (updated === undefined) return;
        if (groupsInclude(updated, category)) {
            window.removeEventListener('OneTrustGroupsUpdated', onUpdate);
            callback();
        }
    };
    window.addEventListener('OneTrustGroupsUpdated', onUpdate);
    return () => window.removeEventListener('OneTrustGroupsUpdated', onUpdate);
};
